import type { GraphQLClient, RequestOptions } from 'graphql-request';
import { gql } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  JSONString: { input: any; output: any; }
};

export type AddCartMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  skuId: Scalars['ID']['input'];
};

export type CancelTradeRequestMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teacherAgent: Scalars['ID']['input'];
};

export type CheckEstimatePdfGeneratedInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};

export type CloneOrderDetailMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderDetailId: Scalars['ID']['input'];
};

export type CreateReviewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  review: Scalars['String']['input'];
  score: Scalars['Int']['input'];
  sku: Scalars['ID']['input'];
};

export type DiscardOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type ForceResetPasswordInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type GetEstimateFileUrlInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};

/** An enumeration. */
export enum MastersGradeSchoolTypeChoices {
  /** 幼稚園（幼稚園型認定こども園含む） */
  A1 = 'A1',
  /** 幼保連携型、認定こども園 */
  A2 = 'A2',
  /** 小学校 */
  B1 = 'B1',
  /** 中学校 */
  C1 = 'C1',
  /** 義務教育学校 */
  C2 = 'C2',
  /** 高等学校 */
  D1 = 'D1',
  /** 中等教育学校 */
  D2 = 'D2',
  /** 特別支援学校 */
  E1 = 'E1',
  /** 大学 */
  F1 = 'F1',
  /** 短期大学 */
  F2 = 'F2',
  /** 高等専門学校 */
  G1 = 'G1',
  /** 専修学校 */
  H1 = 'H1',
  /** 各種学校 */
  H2 = 'H2'
}

export type OrderFromCartItemsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comments: Scalars['JSONString']['input'];
  orderDetailIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type OrderFromEstimateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comments: Scalars['JSONString']['input'];
  id: Scalars['ID']['input'];
};

/** An enumeration. */
export enum ProductsSkuTaxClassChoices {
  /** 非課税 */
  A_0 = 'A_0',
  /** 外税 */
  A_1 = 'A_1',
  /** 内税 */
  _1 = '_1'
}

export type RemoveCartItemMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderDetailId: Scalars['ID']['input'];
};

export type RequestEstimateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comments: Scalars['JSONString']['input'];
  orderDetailIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type RequestResetPasswordInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

export type RequestTradeMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  salesAgent: Scalars['ID']['input'];
};

export type ResetPasswordInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type SignupMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  discloseEmail?: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  firstNameKana: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  lastNameKana: Scalars['String']['input'];
  nickname: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumberPersonal: Scalars['String']['input'];
  phoneNumberWork: Scalars['String']['input'];
  salesAgent: Scalars['ID']['input'];
  school: Scalars['ID']['input'];
  subjectAreas: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type UpdateCartItemMutationInput = {
  byClasses?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['Date']['input']>;
  numOfClass?: InputMaybe<Scalars['Int']['input']>;
  orderDetailId: Scalars['ID']['input'];
  packingType?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityForTeacher?: InputMaybe<Scalars['Int']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  salesAgentId?: InputMaybe<Scalars['ID']['input']>;
  usedByType?: InputMaybe<Scalars['Int']['input']>;
  usingPurposeId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTeacherProfileMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  discloseEmail?: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  firstNameKana: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  lastNameKana: Scalars['String']['input'];
  nickname: Scalars['String']['input'];
  phoneNumberPersonal: Scalars['String']['input'];
  phoneNumberWork: Scalars['String']['input'];
  school: Scalars['ID']['input'];
  subjectAreas: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type VerifyEmailInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};

export type AddCartMutationVariables = Exact<{
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  skuId: Scalars['ID']['input'];
}>;


export type AddCartMutation = { addCart?: { clientMutationId?: string | null, orderDetail?: { id: string } | null } | null };

export type RemoveCartItemMutationVariables = Exact<{
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderDetailId: Scalars['ID']['input'];
}>;


export type RemoveCartItemMutation = { removeCartItem?: { clientMutationId?: string | null } | null };

export type UpdateCartItemMutationVariables = Exact<{
  orderDetailId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['Date']['input']>;
  packingType?: InputMaybe<Scalars['String']['input']>;
  byClasses?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  numOfClass?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityForTeacher?: InputMaybe<Scalars['Int']['input']>;
  usedByType?: InputMaybe<Scalars['Int']['input']>;
  usingPurposeId?: InputMaybe<Scalars['ID']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  salesAgentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateCartItemMutation = { updateCartItem?: { clientMutationId?: string | null } | null };

export type GetCartItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCartItemQuery = { cartItem?: { id: string, createdAt: any, updatedAt: any, quantity?: number | null, quantityForTeacher?: number | null, packingType?: string | null, packingDetails: any, usedByType?: number | null, deliveryDate?: any | null, remarks: string, sku?: { available: boolean, code: string, id: string, isbnCode: string, janCode: string, name: string, publisherSkuUri: string, regularPrice: number, taxClassDisplay?: string | null, taxIncludedPrice: number, taxRate: number, taxClass: ProductsSkuTaxClassChoices, term?: { year: number, name?: string | null, id: string } | null, relatedTextbookPublisher?: { textbookPublisherNumber?: number | null, shortName: string, name: string, id: string } | null, publisher?: { textbookPublisherNumber?: number | null, shortName: string, name: string, id: string } | null, product?: { rating?: number | null, productBaseCode: string, name: string, id: string, subject?: { name: string, id: string, area?: { id: string, name: string } | null } | null } | null, imageUris?: { edges: Array<{ cursor: string, node?: { cdnUrl?: string | null, id: string } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null, grade?: { edges: Array<{ cursor: string, node?: { code?: string | null, gradeName: string, gradeNumber: number, id: string, schoolType: MastersGradeSchoolTypeChoices, schoolTypeDisplay?: string | null } | null } | null>, pageInfo: { startCursor?: string | null, hasPreviousPage: boolean, endCursor?: string | null, hasNextPage: boolean } } | null } | null, salesAgent?: { id: string, name: string, faxNumber: string, address2: string, address1: string, phoneNumber: string, postalCode: string, manualOrderFormUrl: string } | null, usingPurpose?: { id: string, code: string, label: string } | null } | null };

export type GetCartItemsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type GetCartItemsQuery = { allCartItems?: { pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, edges: Array<{ cursor: string, node?: { id: string, createdAt: any, updatedAt: any, quantity?: number | null, quantityForTeacher?: number | null, packingType?: string | null, packingDetails: any, usedByType?: number | null, deliveryDate?: any | null, remarks: string, sku?: { available: boolean, code: string, id: string, isbnCode: string, janCode: string, name: string, publisherSkuUri: string, regularPrice: number, taxClassDisplay?: string | null, taxIncludedPrice: number, taxRate: number, taxClass: ProductsSkuTaxClassChoices, term?: { year: number, name?: string | null, id: string } | null, relatedTextbookPublisher?: { textbookPublisherNumber?: number | null, shortName: string, name: string, id: string } | null, publisher?: { textbookPublisherNumber?: number | null, shortName: string, name: string, id: string } | null, product?: { rating?: number | null, productBaseCode: string, name: string, id: string, subject?: { name: string, id: string, area?: { id: string, name: string } | null } | null } | null, imageUris?: { edges: Array<{ cursor: string, node?: { cdnUrl?: string | null, id: string } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null, grade?: { edges: Array<{ cursor: string, node?: { code?: string | null, gradeName: string, gradeNumber: number, id: string, schoolType: MastersGradeSchoolTypeChoices, schoolTypeDisplay?: string | null } | null } | null>, pageInfo: { startCursor?: string | null, hasPreviousPage: boolean, endCursor?: string | null, hasNextPage: boolean } } | null } | null, salesAgent?: { id: string, name: string, faxNumber: string, address2: string, address1: string, phoneNumber: string, postalCode: string, manualOrderFormUrl: string } | null, usingPurpose?: { id: string, code: string, label: string } | null } | null } | null> } | null };

export type GetCitiesQueryVariables = Exact<{
  prefCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCitiesQuery = { allCities?: { edges: Array<{ cursor: string, node?: { code?: string | null, id: string, name?: string | null, prefCode?: string | null } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigsQuery = { siteConfigs?: Array<{ key: string, value?: string | null } | null> | null };

export type EmailVerifyMutationVariables = Exact<{
  key: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmailVerifyMutation = { verifyEmail?: { clientMutationId?: string | null } | null };

export type GetEmailVerifyQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type GetEmailVerifyQuery = { verifyEmail?: { emailAddress?: string | null } | null };

export type RequestEstimateMutationVariables = Exact<{
  orderDetailIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  comments?: InputMaybe<Scalars['JSONString']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestEstimateMutation = { requestEstimate?: { clientMutationId?: string | null, orderGroup?: { id: string } | null } | null };

export type CheckEstimatePdfGeneratedMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckEstimatePdfGeneratedMutation = { checkEstimatePdfGenerated?: { clientMutationId?: string | null, isGenerated?: boolean | null } | null };

export type GetEstimateFileUrlMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEstimateFileUrlMutation = { getEstimateFileUrl?: { clientMutationId?: string | null, url?: string | null } | null };

export type GetGradeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetGradeQuery = { grade?: { id: string, gradeName: string, gradeNumber: number, schoolType: MastersGradeSchoolTypeChoices, schoolTypeDisplay?: string | null, code?: string | null } | null };

export type GetGradesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGradesQuery = { allGrades?: { __typename: 'GradeNodeConnection', edges: Array<{ cursor: string, node?: { id: string, gradeName: string, gradeNumber: number, schoolType: MastersGradeSchoolTypeChoices, schoolTypeDisplay?: string | null, code?: string | null } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetOrdersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  createdAt_Year?: InputMaybe<Scalars['Decimal']['input']>;
}>;


export type GetOrdersQuery = { allOrders?: { edges: Array<{ cursor: string, node?: { id: string, isDiscard: boolean, estimateIssueDatetime?: any | null, orderDatetime?: any | null, comment: string, createdAt: any, updatedAt: any, orderDetails?: { edges: Array<{ cursor: string, node?: { id: string, deliveryDate?: any | null, quantity?: number | null, quantityForTeacher?: number | null, usedByType?: number | null, packingType?: string | null, packingDetails: any, remarks: string, usingPurpose?: { id: string, code: string, label: string } | null, salesAgent?: { id: string, name: string, faxNumber: string, address2: string, address1: string, phoneNumber: string, postalCode: string, manualOrderFormUrl: string } | null, sku?: { id: string, code: string, isbnCode: string, janCode: string, name: string, publisherSkuUri: string, regularPrice: number, taxClass: ProductsSkuTaxClassChoices, taxClassDisplay?: string | null, taxIncludedPrice: number, taxRate: number, available: boolean, publisher?: { id: string, name: string } | null, relatedTextbookPublisher?: { id: string, name: string } | null, term?: { id: string, name?: string | null, year: number } | null, grade?: { edges: Array<{ cursor: string, node?: { code?: string | null, gradeName: string, gradeNumber: number, id: string, schoolType: MastersGradeSchoolTypeChoices, schoolTypeDisplay?: string | null } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null, imageUris?: { pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, edges: Array<{ cursor: string, node?: { cdnUrl?: string | null, id: string } | null } | null> } | null, product?: { id: string, name: string, productBaseCode: string, rating?: number | null, subject?: { id: string, name: string, area?: { id: string, name: string } | null } | null } | null } | null, user?: { id: string, email?: string | null, firstName: string, firstNameKana: string, lastName: string, lastNameKana: string, teacherProfile?: { customerId: string } | null } | null } | null } | null> } | null, salesAgent: { id: string, name: string, faxNumber: string, address2: string, address1: string, phoneNumber: string, postalCode: string, manualOrderFormUrl: string } } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type ObtainOrderIdByGroupOrderIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ObtainOrderIdByGroupOrderIdQuery = { orderGroup?: { id: string, orders?: { edges: Array<{ cursor: string, node?: { id: string, salesAgent: { id: string, name: string } } | null } | null> } | null } | null };

export type GetLastUpdatedOrderDetailQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLastUpdatedOrderDetailQuery = { lastUpdatedOrderDetail?: { id: string, packingType?: string | null, packingDetails: any, quantity?: number | null, quantityForTeacher?: number | null, usedByType?: number | null, deliveryDate?: any | null, remarks: string, updatedAt: any, createdAt: any, usingPurpose?: { id: string, code: string, label: string } | null, salesAgent?: { id: string, name: string, faxNumber: string, address2: string, address1: string, phoneNumber: string, postalCode: string, manualOrderFormUrl: string } | null } | null };

export type OrderByCartItemsMutationVariables = Exact<{
  orderDetailIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  comments?: InputMaybe<Scalars['JSONString']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderByCartItemsMutation = { orderFromCartItems?: { clientMutationId?: string | null, orderGroup?: { id: string, orders?: { edges: Array<{ cursor: string, node?: { id: string, orderDetails?: { edges: Array<{ cursor: string, node?: { id: string } | null } | null> } | null } | null } | null> } | null } | null } | null };

export type GetOrderGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrderGroupQuery = { orderGroup?: { createdAt: any, id: string, updatedAt: any, user?: { id: string, email?: string | null, firstName: string, firstNameKana: string, lastName: string, lastNameKana: string, teacherProfile?: { customerId: string } | null } | null, orders?: { edges: Array<{ cursor: string, node?: { id: string, isDiscard: boolean, estimateIssueDatetime?: any | null, orderDatetime?: any | null, comment: string, createdAt: any, updatedAt: any, orderDetails?: { edges: Array<{ cursor: string, node?: { id: string, deliveryDate?: any | null, quantity?: number | null, quantityForTeacher?: number | null, usedByType?: number | null, packingType?: string | null, packingDetails: any, remarks: string, createdAt: any, updatedAt: any, usingPurpose?: { id: string, code: string, label: string } | null, salesAgent?: { id: string, name: string, faxNumber: string, address2: string, address1: string, phoneNumber: string, postalCode: string, manualOrderFormUrl: string } | null, sku?: { id: string, code: string, isbnCode: string, janCode: string, name: string, publisherSkuUri: string, regularPrice: number, taxClass: ProductsSkuTaxClassChoices, taxClassDisplay?: string | null, taxIncludedPrice: number, taxRate: number, available: boolean, publisher?: { id: string, name: string } | null, relatedTextbookPublisher?: { id: string, name: string } | null, term?: { id: string, name?: string | null, year: number } | null, grade?: { edges: Array<{ cursor: string, node?: { code?: string | null, gradeName: string, gradeNumber: number, id: string, schoolType: MastersGradeSchoolTypeChoices, schoolTypeDisplay?: string | null } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null, imageUris?: { pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, edges: Array<{ cursor: string, node?: { cdnUrl?: string | null, id: string } | null } | null> } | null, product?: { id: string, name: string, productBaseCode: string, rating?: number | null, subject?: { id: string, name: string, area?: { id: string, name: string } | null } | null } | null } | null, user?: { id: string, email?: string | null, firstName: string, firstNameKana: string, lastName: string, lastNameKana: string, teacherProfile?: { customerId: string } | null } | null } | null } | null> } | null, salesAgent: { id: string, name: string, faxNumber: string, address2: string, address1: string, phoneNumber: string, postalCode: string, manualOrderFormUrl: string } } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null } | null };

export type GetOrderGroupsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  createdAt_Year?: InputMaybe<Scalars['Decimal']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrderGroupsQuery = { allOrderGroups?: { totalCount: number, edges: Array<{ cursor: string, node?: { createdAt: any, id: string, updatedAt: any, user?: { id: string, email?: string | null, firstName: string, firstNameKana: string, lastName: string, lastNameKana: string, teacherProfile?: { customerId: string } | null } | null, orders?: { edges: Array<{ cursor: string, node?: { id: string, isDiscard: boolean, estimateIssueDatetime?: any | null, orderDatetime?: any | null, comment: string, createdAt: any, updatedAt: any, orderDetails?: { edges: Array<{ cursor: string, node?: { id: string, deliveryDate?: any | null, quantity?: number | null, quantityForTeacher?: number | null, usedByType?: number | null, packingType?: string | null, packingDetails: any, remarks: string, createdAt: any, updatedAt: any, usingPurpose?: { id: string, code: string, label: string } | null, salesAgent?: { id: string, name: string, faxNumber: string, address2: string, address1: string, phoneNumber: string, postalCode: string, manualOrderFormUrl: string } | null, sku?: { id: string, code: string, isbnCode: string, janCode: string, name: string, publisherSkuUri: string, regularPrice: number, taxClass: ProductsSkuTaxClassChoices, taxClassDisplay?: string | null, taxIncludedPrice: number, taxRate: number, available: boolean, publisher?: { id: string, name: string } | null, relatedTextbookPublisher?: { id: string, name: string } | null, term?: { id: string, name?: string | null, year: number } | null, grade?: { edges: Array<{ cursor: string, node?: { code?: string | null, gradeName: string, gradeNumber: number, id: string, schoolType: MastersGradeSchoolTypeChoices, schoolTypeDisplay?: string | null } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null, imageUris?: { pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, edges: Array<{ cursor: string, node?: { cdnUrl?: string | null, id: string } | null } | null> } | null, product?: { id: string, name: string, productBaseCode: string, rating?: number | null, subject?: { id: string, name: string, area?: { id: string, name: string } | null } | null } | null } | null, user?: { email?: string | null, firstName: string, firstNameKana: string, id: string, lastName: string, lastNameKana: string, teacherProfile?: { customerId: string } | null } | null } | null } | null> } | null, salesAgent: { id: string, name: string, faxNumber: string, address2: string, address1: string, phoneNumber: string, postalCode: string, manualOrderFormUrl: string } } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type DiscardOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DiscardOrderMutation = { discardOrder?: { clientMutationId?: string | null } | null };

export type OrderFromEstimateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  comments?: InputMaybe<Scalars['JSONString']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderFromEstimateMutation = { orderFromEstimate?: { clientMutationId?: string | null, orderGroup?: { id: string, orders?: { edges: Array<{ cursor: string, node?: { id: string, orderDetails?: { edges: Array<{ cursor: string, node?: { id: string } | null } | null> } | null } | null } | null> } | null } | null } | null };

export type GetOrderGroupsCountQueryVariables = Exact<{
  isDiscarded?: InputMaybe<Scalars['Boolean']['input']>;
  isOrdered?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrderGroupsCountQuery = { allOrderGroups?: { totalCount: number } | null };

export type GetPrefecturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPrefecturesQuery = { allPrefectures?: Array<{ code: string, name: string } | null> | null };

export type GetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileQuery = { me?: { email?: string | null, firstName: string, firstNameKana: string, id: string, lastName: string, lastNameKana: string, phoneNumberPersonal: string, phoneNumberWork: string, teacherProfile?: { id: string, customerId: string, dateOfBirth?: any | null, discloseEmail: boolean, nickname: string, school?: { address: string, faxNumber: string, id: string, name: string, phoneNumber: string, postalCode: string, schoolCode: string, cityCode: string } | null, salesAgent?: { id: string, name: string, phoneNumber: string, faxNumber: string, postalCode: string, address1: string, address2: string, manualOrderFormUrl: string } | null, subjectAreas?: { edges: Array<{ cursor: string, node?: { id: string, name: string } | null } | null>, pageInfo: { startCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: string | null } } | null } | null, teacherAgents?: { edges: Array<{ cursor: string, node?: { id: string, approval: boolean, salesAgent?: { id: string, name: string, phoneNumber: string, postalCode: string, faxNumber: string, address2: string, address1: string, manualOrderFormUrl: string } | null } | null } | null>, pageInfo: { startCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type UpdateProfileMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  firstNameKana: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  lastNameKana: Scalars['String']['input'];
  nickname: Scalars['String']['input'];
  phoneNumberPersonal: Scalars['String']['input'];
  phoneNumberWork: Scalars['String']['input'];
  school: Scalars['ID']['input'];
  subjectAreas: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  discloseEmail: Scalars['Boolean']['input'];
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProfileMutation = { updateTeacherProfile?: { clientMutationId?: string | null } | null };

export type GetPublisherQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPublisherQuery = { publisher?: { id: string, name: string, shortName: string, textbookPublisherNumber?: number | null } | null };

export type GetPublishersQueryVariables = Exact<{
  isTextbookPublisher?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPublishersQuery = { allPublishers?: { edges: Array<{ cursor: string, node?: { id: string, name: string, shortName: string, textbookPublisherNumber?: number | null } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetQAndAsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQAndAsQuery = { allQAndAs?: { edges: Array<{ cursor: string, node?: { content: string, id: string, title: string } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type ForcePasswordResetMutationVariables = Exact<{
  password: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ForcePasswordResetMutation = { forceResetPassword?: { clientMutationId?: string | null } | null };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestPasswordResetMutation = { requestResetPassword?: { clientMutationId?: string | null } | null };

export type PasswordResetMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PasswordResetMutation = { resetPassword?: { clientMutationId?: string | null } | null };

export type GetProductReviewStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProductReviewStatusQuery = { productReviewStatus?: { id: string, isPurchased?: boolean | null, review?: { id: string, review: string, score: number } | null } | null };

export type GetReviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetReviewQuery = { review?: { id: string, review: string, score: number, user?: { email?: string | null, teacherProfile?: { discloseEmail: boolean, nickname: string } | null } | null } | null };

export type GetReviewsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetReviewsQuery = { allReviews?: { edges: Array<{ cursor: string, node?: { id: string, review: string, score: number, createdAt: any, user?: { email?: string | null, teacherProfile?: { discloseEmail: boolean, nickname: string } | null } | null } | null } | null> } | null };

export type ReviewCreateMutationVariables = Exact<{
  sku: Scalars['ID']['input'];
  score: Scalars['Int']['input'];
  review: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReviewCreateMutation = { createReview?: { clientMutationId?: string | null } | null };

export type GetSalesAgentsFilteredSchoolQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSalesAgentsFilteredSchoolQuery = { allSalesAgentsFilteredSchool?: { edges: Array<{ cursor: string, node?: { address1: string, address2: string, faxNumber: string, id: string, name: string, phoneNumber: string, postalCode: string, manualOrderFormUrl: string } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetSalesAgentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSalesAgentQuery = { salesAgent?: { address1: string, address2: string, faxNumber: string, id: string, name: string, phoneNumber: string, postalCode: string, manualOrderFormUrl: string } | null };

export type GetSchoolsQueryVariables = Exact<{
  cityCode?: InputMaybe<Scalars['String']['input']>;
  schoolCode?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSchoolsQuery = { allSchools?: { edges: Array<{ cursor: string, node?: { id: string, name: string } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetSchoolQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSchoolQuery = { school?: { address: string, faxNumber: string, id: string, name: string, phoneNumber: string, postalCode: string, schoolCode: string, cityCode: string } | null };

export type GetSchoolSubjectsQueryVariables = Exact<{
  school: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['ID']['input']>;
  grade?: InputMaybe<Scalars['ID']['input']>;
  subject?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSchoolSubjectsQuery = { allSchoolSubjects?: { totalCount: number, edges: Array<{ cursor: string, node?: { id: string, publisher: { textbookPublisherNumber?: number | null, shortName: string, name: string, id: string } } | null } | null> } | null };

export type SignupMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  firstNameKana: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  lastNameKana: Scalars['String']['input'];
  nickname: Scalars['String']['input'];
  phoneNumberPersonal: Scalars['String']['input'];
  phoneNumberWork: Scalars['String']['input'];
  school: Scalars['ID']['input'];
  salesAgent: Scalars['ID']['input'];
  subjectAreas: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  discloseEmail: Scalars['Boolean']['input'];
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SignupMutation = { signup?: { clientMutationId?: string | null } | null };

export type GetSkuQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  productReviewsAfter?: InputMaybe<Scalars['String']['input']>;
  productReviewsBefore?: InputMaybe<Scalars['String']['input']>;
  productReviewsFirst?: InputMaybe<Scalars['Int']['input']>;
  productReviewsOffset?: InputMaybe<Scalars['Int']['input']>;
  productReviewsLast?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSkuQuery = { sku?: { available: boolean, code: string, id: string, isbnCode: string, janCode: string, name: string, publisherSkuUri: string, regularPrice: number, taxClass: ProductsSkuTaxClassChoices, taxClassDisplay?: string | null, taxIncludedPrice: number, taxRate: number, product?: { id: string, name: string, productBaseCode: string, rating?: number | null, reviews?: { edges: Array<{ cursor: string, node?: { id: string, review: string, score: number, createdAt: any, user?: { email?: string | null, teacherProfile?: { discloseEmail: boolean, nickname: string } | null } | null } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null, subject?: { id: string, name: string, area?: { id: string, name: string } | null } | null } | null, imageUris?: { pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, edges: Array<{ cursor: string, node?: { cdnUrl?: string | null, id: string } | null } | null> } | null, grade?: { edges: Array<{ cursor: string, node?: { code?: string | null, gradeName: string, gradeNumber: number, id: string, schoolType: MastersGradeSchoolTypeChoices, schoolTypeDisplay?: string | null } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null, publisher?: { id: string, name: string } | null, relatedTextbookPublisher?: { id: string, name: string } | null, term?: { id: string, name?: string | null, year: number } | null } | null };

export type GetProductReviewsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  productReviewsAfter?: InputMaybe<Scalars['String']['input']>;
  productReviewsBefore?: InputMaybe<Scalars['String']['input']>;
  productReviewsFirst?: InputMaybe<Scalars['Int']['input']>;
  productReviewsOffset?: InputMaybe<Scalars['Int']['input']>;
  productReviewsLast?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProductReviewsQuery = { sku?: { product?: { reviews?: { edges: Array<{ cursor: string, node?: { id: string, review: string, score: number, createdAt: any, user?: { email?: string | null, teacherProfile?: { discloseEmail: boolean, nickname: string } | null } | null } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null } | null } | null };

export type GetLatestSkuQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  relatedTextbookPublisher?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetLatestSkuQuery = { latestSku?: { id: string } | null };

export type SearchSkuQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  available?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  grade?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  isbnCode?: InputMaybe<Scalars['String']['input']>;
  isCompliantOnly?: InputMaybe<Scalars['Boolean']['input']>;
  janCode?: InputMaybe<Scalars['String']['input']>;
  janIsbnCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_Subject?: InputMaybe<Scalars['ID']['input']>;
  product_Subject_Area?: InputMaybe<Scalars['ID']['input']>;
  publisher_Name?: InputMaybe<Scalars['String']['input']>;
  taxIncludedPrice_Gte?: InputMaybe<Scalars['Int']['input']>;
  taxIncludedPrice_Lte?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['ID']['input']>;
  relatedTextbookPublisher?: InputMaybe<Scalars['ID']['input']>;
  withoutNoRelatedTextbookPublisher?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchSkuQuery = { allSkus?: { totalCount: number, edges: Array<{ cursor: string, node?: { available: boolean, code: string, id: string, isbnCode: string, janCode: string, name: string, publisherSkuUri: string, regularPrice: number, taxClass: ProductsSkuTaxClassChoices, taxClassDisplay?: string | null, taxRate: number, taxIncludedPrice: number, publisher?: { id: string, name: string, shortName: string, textbookPublisherNumber?: number | null } | null, relatedTextbookPublisher?: { id: string, name: string, shortName: string, textbookPublisherNumber?: number | null } | null, grade?: { edges: Array<{ cursor: string, node?: { id: string, gradeName: string, gradeNumber: number, schoolType: MastersGradeSchoolTypeChoices, schoolTypeDisplay?: string | null, code?: string | null } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null, term?: { id: string, name?: string | null, year: number } | null, product?: { id: string, name: string, productBaseCode: string, rating?: number | null, subject?: { id: string, name: string, area?: { name: string } | null } | null } | null, imageUris?: { edges: Array<{ cursor: string, node?: { id: string, cdnUrl?: string | null } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetSubjectAreasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubjectAreasQuery = { allSubjectAreas?: { edges: Array<{ cursor: string, node?: { id: string, name: string } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetSubjectAreaQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSubjectAreaQuery = { subjectArea?: { id: string, name: string } | null };

export type GetSubjectsQueryVariables = Exact<{
  area?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSubjectsQuery = { allSubjects?: { edges: Array<{ cursor: string, node?: { id: string, name: string, area?: { id: string, name: string } | null } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetSubjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSubjectQuery = { subject?: { id: string, name: string, area?: { id: string, name: string } | null } | null };

export type GetTermQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTermQuery = { term?: { id: string, name?: string | null, year: number } | null };

export type GetTermsQueryVariables = Exact<{
  year?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTermsQuery = { allTerms?: { edges: Array<{ cursor: string, node?: { id: string, name?: string | null, year: number } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type TradeRequestMutationVariables = Exact<{
  salesAgent: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TradeRequestMutation = { requestTrade?: { clientMutationId?: string | null, teacherAgent?: { id: string, salesAgent?: { id: string } | null } | null } | null };

export type TradeRequestCancelMutationVariables = Exact<{
  teacherAgent: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TradeRequestCancelMutation = { cancelTradeRequest?: { clientMutationId?: string | null } | null };

export type GetTeacherAgentsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  salesAgent?: InputMaybe<Scalars['ID']['input']>;
  salesAgent_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  approval?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTeacherAgentsQuery = { allTeacherAgents?: { edges: Array<{ cursor: string, node?: { approval: boolean, id: string, isHandledSchool?: boolean | null, salesAgent?: { address1: string, address2: string, faxNumber: string, name: string, phoneNumber: string, postalCode: string, id: string, manualOrderFormUrl: string } | null } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type GetUsingPurposeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUsingPurposeQuery = { usingPurpose?: { code: string, id: string, label: string } | null };

export type GetUsingPurposesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsingPurposesQuery = { allUsingPurposes?: { edges: Array<{ cursor: string, node?: { code: string, id: string, label: string } | null } | null>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };


export const AddCartDocument = gql`
    mutation AddCart($clientMutationId: String = null, $skuId: ID!) {
  addCart(input: {skuId: $skuId, clientMutationId: $clientMutationId}) {
    clientMutationId
    orderDetail {
      id
    }
  }
}
    `;
export const RemoveCartItemDocument = gql`
    mutation RemoveCartItem($clientMutationId: String = null, $orderDetailId: ID!) {
  removeCartItem(
    input: {orderDetailId: $orderDetailId, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
  }
}
    `;
export const UpdateCartItemDocument = gql`
    mutation UpdateCartItem($orderDetailId: ID!, $clientMutationId: String = null, $deliveryDate: Date = null, $packingType: String = null, $byClasses: [Int] = null, $numOfClass: Int = null, $quantity: Int = null, $quantityForTeacher: Int = null, $usedByType: Int = null, $usingPurposeId: ID = null, $remarks: String = null, $salesAgentId: ID = null) {
  updateCartItem(
    input: {orderDetailId: $orderDetailId, salesAgentId: $salesAgentId, quantity: $quantity, quantityForTeacher: $quantityForTeacher, packingType: $packingType, byClasses: $byClasses, numOfClass: $numOfClass, deliveryDate: $deliveryDate, usedByType: $usedByType, usingPurposeId: $usingPurposeId, remarks: $remarks, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
  }
}
    `;
export const GetCartItemDocument = gql`
    query GetCartItem($id: ID!) {
  cartItem(id: $id) {
    id
    createdAt
    updatedAt
    sku {
      available
      code
      id
      isbnCode
      janCode
      name
      publisherSkuUri
      regularPrice
      taxClassDisplay
      taxIncludedPrice
      taxRate
      term {
        year
        name
        id
      }
      taxClass
      relatedTextbookPublisher {
        textbookPublisherNumber
        shortName
        name
        id
      }
      publisher {
        textbookPublisherNumber
        shortName
        name
        id
      }
      product {
        rating
        productBaseCode
        name
        id
        subject {
          name
          id
          area {
            id
            name
          }
        }
      }
      imageUris {
        edges {
          cursor
          node {
            cdnUrl
            id
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
      grade {
        edges {
          cursor
          node {
            code
            gradeName
            gradeNumber
            id
            schoolType
            schoolTypeDisplay
          }
        }
        pageInfo {
          startCursor
          hasPreviousPage
          endCursor
          hasNextPage
        }
      }
    }
    salesAgent {
      id
      name
      faxNumber
      address2
      address1
      phoneNumber
      postalCode
      manualOrderFormUrl
    }
    quantity
    quantityForTeacher
    packingType
    packingDetails
    usedByType
    usingPurpose {
      id
      code
      label
    }
    deliveryDate
    remarks
  }
}
    `;
export const GetCartItemsDocument = gql`
    query GetCartItems($after: String = null, $before: String = null, $first: Int = null, $last: Int = null, $id_In: [ID] = null) {
  allCartItems(
    after: $after
    before: $before
    first: $first
    last: $last
    id_In: $id_In
  ) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
      node {
        id
        createdAt
        updatedAt
        sku {
          available
          code
          id
          isbnCode
          janCode
          name
          publisherSkuUri
          regularPrice
          taxClassDisplay
          taxIncludedPrice
          taxRate
          term {
            year
            name
            id
          }
          taxClass
          relatedTextbookPublisher {
            textbookPublisherNumber
            shortName
            name
            id
          }
          publisher {
            textbookPublisherNumber
            shortName
            name
            id
          }
          product {
            rating
            productBaseCode
            name
            id
            subject {
              name
              id
              area {
                id
                name
              }
            }
          }
          imageUris {
            edges {
              cursor
              node {
                cdnUrl
                id
              }
            }
            pageInfo {
              endCursor
              hasNextPage
              hasPreviousPage
              startCursor
            }
          }
          grade {
            edges {
              cursor
              node {
                code
                gradeName
                gradeNumber
                id
                schoolType
                schoolTypeDisplay
              }
            }
            pageInfo {
              startCursor
              hasPreviousPage
              endCursor
              hasNextPage
            }
          }
        }
        salesAgent {
          id
          name
          faxNumber
          address2
          address1
          phoneNumber
          postalCode
          manualOrderFormUrl
        }
        quantity
        quantityForTeacher
        packingType
        packingDetails
        usedByType
        usingPurpose {
          id
          code
          label
        }
        deliveryDate
        remarks
      }
    }
  }
}
    `;
export const GetCitiesDocument = gql`
    query GetCities($prefCode: String = null) {
  allCities(prefCode: $prefCode) {
    edges {
      cursor
      node {
        code
        id
        name
        prefCode
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const GetConfigsDocument = gql`
    query GetConfigs {
  siteConfigs {
    key
    value
  }
}
    `;
export const EmailVerifyDocument = gql`
    mutation EmailVerify($key: String!, $clientMutationId: String = null) {
  verifyEmail(input: {key: $key, clientMutationId: $clientMutationId}) {
    clientMutationId
  }
}
    `;
export const GetEmailVerifyDocument = gql`
    query GetEmailVerify($key: String!) {
  verifyEmail(key: $key) {
    emailAddress
  }
}
    `;
export const RequestEstimateDocument = gql`
    mutation RequestEstimate($orderDetailIds: [ID] = [], $comments: JSONString = "[]", $clientMutationId: String = null) {
  requestEstimate(
    input: {orderDetailIds: $orderDetailIds, comments: $comments, clientMutationId: $clientMutationId}
  ) {
    orderGroup {
      id
    }
    clientMutationId
  }
}
    `;
export const CheckEstimatePdfGeneratedDocument = gql`
    mutation CheckEstimatePdfGenerated($orderId: ID!, $clientMutationId: String = null) {
  checkEstimatePdfGenerated(
    input: {orderId: $orderId, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
    isGenerated
  }
}
    `;
export const GetEstimateFileUrlDocument = gql`
    mutation GetEstimateFileUrl($orderId: ID!, $clientMutationId: String = null) {
  getEstimateFileUrl(
    input: {orderId: $orderId, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
    url
  }
}
    `;
export const GetGradeDocument = gql`
    query GetGrade($id: ID!) {
  grade(id: $id) {
    id
    gradeName
    gradeNumber
    schoolType
    schoolTypeDisplay
    code
  }
}
    `;
export const GetGradesDocument = gql`
    query GetGrades {
  allGrades {
    __typename
    edges {
      cursor
      node {
        id
        gradeName
        gradeNumber
        schoolType
        schoolTypeDisplay
        code
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const GetOrdersDocument = gql`
    query GetOrders($after: String = null, $before: String = null, $first: Int = null, $last: Int = null, $offset: Int = null, $createdAt_Year: Decimal = null) {
  allOrders(
    after: $after
    before: $before
    first: $first
    last: $last
    offset: $offset
    createdAt_Year: $createdAt_Year
  ) {
    edges {
      cursor
      node {
        id
        isDiscard
        estimateIssueDatetime
        orderDatetime
        comment
        orderDetails {
          edges {
            cursor
            node {
              id
              usingPurpose {
                id
                code
                label
              }
              deliveryDate
              quantity
              quantityForTeacher
              usedByType
              packingType
              packingDetails
              remarks
              salesAgent {
                id
                name
                faxNumber
                address2
                address1
                phoneNumber
                postalCode
                manualOrderFormUrl
              }
              sku {
                id
                code
                isbnCode
                janCode
                name
                publisherSkuUri
                regularPrice
                taxClass
                taxClassDisplay
                taxIncludedPrice
                taxRate
                available
                publisher {
                  id
                  name
                }
                relatedTextbookPublisher {
                  id
                  name
                }
                term {
                  id
                  name
                  year
                }
                grade {
                  edges {
                    cursor
                    node {
                      code
                      gradeName
                      gradeNumber
                      id
                      schoolType
                      schoolTypeDisplay
                    }
                  }
                  pageInfo {
                    endCursor
                    hasNextPage
                    hasPreviousPage
                    startCursor
                  }
                }
                imageUris {
                  pageInfo {
                    endCursor
                    hasNextPage
                    hasPreviousPage
                    startCursor
                  }
                  edges {
                    node {
                      cdnUrl
                      id
                    }
                    cursor
                  }
                }
                product {
                  id
                  name
                  productBaseCode
                  rating
                  subject {
                    id
                    name
                    area {
                      id
                      name
                    }
                  }
                }
              }
              user {
                id
                email
                firstName
                firstNameKana
                lastName
                lastNameKana
                teacherProfile {
                  customerId
                }
              }
            }
          }
        }
        salesAgent {
          id
          name
          faxNumber
          address2
          address1
          phoneNumber
          postalCode
          manualOrderFormUrl
        }
        createdAt
        updatedAt
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const ObtainOrderIdByGroupOrderIdDocument = gql`
    query ObtainOrderIdByGroupOrderId($id: ID!) {
  orderGroup(id: $id) {
    id
    orders {
      edges {
        node {
          id
          salesAgent {
            id
            name
          }
        }
        cursor
      }
    }
  }
}
    `;
export const GetLastUpdatedOrderDetailDocument = gql`
    query GetLastUpdatedOrderDetail {
  lastUpdatedOrderDetail {
    id
    packingType
    packingDetails
    quantity
    quantityForTeacher
    usedByType
    usingPurpose {
      id
      code
      label
    }
    deliveryDate
    remarks
    salesAgent {
      id
      name
      faxNumber
      address2
      address1
      phoneNumber
      postalCode
      manualOrderFormUrl
    }
    updatedAt
    createdAt
  }
}
    `;
export const OrderByCartItemsDocument = gql`
    mutation OrderByCartItems($orderDetailIds: [ID]!, $comments: JSONString = "[]", $clientMutationId: String = null) {
  orderFromCartItems(
    input: {orderDetailIds: $orderDetailIds, comments: $comments, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
    orderGroup {
      id
      orders {
        edges {
          node {
            id
            orderDetails {
              edges {
                cursor
                node {
                  id
                }
              }
            }
          }
          cursor
        }
      }
    }
  }
}
    `;
export const GetOrderGroupDocument = gql`
    query GetOrderGroup($id: ID!) {
  orderGroup(id: $id) {
    createdAt
    id
    updatedAt
    user {
      id
      email
      firstName
      firstNameKana
      lastName
      lastNameKana
      teacherProfile {
        customerId
      }
    }
    orders {
      edges {
        cursor
        node {
          id
          isDiscard
          estimateIssueDatetime
          orderDatetime
          comment
          orderDetails {
            edges {
              cursor
              node {
                id
                usingPurpose {
                  id
                  code
                  label
                }
                deliveryDate
                quantity
                quantityForTeacher
                usedByType
                packingType
                packingDetails
                remarks
                createdAt
                updatedAt
                salesAgent {
                  id
                  name
                  faxNumber
                  address2
                  address1
                  phoneNumber
                  postalCode
                  manualOrderFormUrl
                }
                sku {
                  id
                  code
                  isbnCode
                  janCode
                  name
                  publisherSkuUri
                  regularPrice
                  taxClass
                  taxClassDisplay
                  taxIncludedPrice
                  taxRate
                  available
                  publisher {
                    id
                    name
                  }
                  relatedTextbookPublisher {
                    id
                    name
                  }
                  term {
                    id
                    name
                    year
                  }
                  grade {
                    edges {
                      cursor
                      node {
                        code
                        gradeName
                        gradeNumber
                        id
                        schoolType
                        schoolTypeDisplay
                      }
                    }
                    pageInfo {
                      endCursor
                      hasNextPage
                      hasPreviousPage
                      startCursor
                    }
                  }
                  imageUris {
                    pageInfo {
                      endCursor
                      hasNextPage
                      hasPreviousPage
                      startCursor
                    }
                    edges {
                      node {
                        cdnUrl
                        id
                      }
                      cursor
                    }
                  }
                  product {
                    id
                    name
                    productBaseCode
                    rating
                    subject {
                      id
                      name
                      area {
                        id
                        name
                      }
                    }
                  }
                }
                user {
                  id
                  email
                  firstName
                  firstNameKana
                  lastName
                  lastNameKana
                  teacherProfile {
                    customerId
                  }
                }
              }
            }
          }
          salesAgent {
            id
            name
            faxNumber
            address2
            address1
            phoneNumber
            postalCode
            manualOrderFormUrl
          }
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    `;
export const GetOrderGroupsDocument = gql`
    query GetOrderGroups($after: String = null, $before: String = null, $first: Int = null, $last: Int = null, $offset: Int = null, $createdAt_Year: Decimal = null, $orderBy: String = null) {
  allOrderGroups(
    after: $after
    before: $before
    first: $first
    last: $last
    offset: $offset
    createdAt_Year: $createdAt_Year
    orderBy: $orderBy
  ) {
    totalCount
    edges {
      cursor
      node {
        createdAt
        id
        updatedAt
        user {
          id
          email
          firstName
          firstNameKana
          lastName
          lastNameKana
          teacherProfile {
            customerId
          }
        }
        orders {
          edges {
            cursor
            node {
              id
              isDiscard
              estimateIssueDatetime
              orderDatetime
              comment
              orderDetails {
                edges {
                  cursor
                  node {
                    id
                    usingPurpose {
                      id
                      code
                      label
                    }
                    deliveryDate
                    quantity
                    quantityForTeacher
                    usedByType
                    packingType
                    packingDetails
                    remarks
                    createdAt
                    updatedAt
                    salesAgent {
                      id
                      name
                      faxNumber
                      address2
                      address1
                      phoneNumber
                      postalCode
                      manualOrderFormUrl
                    }
                    sku {
                      id
                      code
                      isbnCode
                      janCode
                      name
                      publisherSkuUri
                      regularPrice
                      taxClass
                      taxClassDisplay
                      taxIncludedPrice
                      taxRate
                      available
                      publisher {
                        id
                        name
                      }
                      relatedTextbookPublisher {
                        id
                        name
                      }
                      term {
                        id
                        name
                        year
                      }
                      grade {
                        edges {
                          cursor
                          node {
                            code
                            gradeName
                            gradeNumber
                            id
                            schoolType
                            schoolTypeDisplay
                          }
                        }
                        pageInfo {
                          endCursor
                          hasNextPage
                          hasPreviousPage
                          startCursor
                        }
                      }
                      imageUris {
                        pageInfo {
                          endCursor
                          hasNextPage
                          hasPreviousPage
                          startCursor
                        }
                        edges {
                          node {
                            cdnUrl
                            id
                          }
                          cursor
                        }
                      }
                      product {
                        id
                        name
                        productBaseCode
                        rating
                        subject {
                          id
                          name
                          area {
                            id
                            name
                          }
                        }
                      }
                    }
                    user {
                      email
                      firstName
                      firstNameKana
                      id
                      lastName
                      lastNameKana
                      teacherProfile {
                        customerId
                      }
                    }
                  }
                }
              }
              salesAgent {
                id
                name
                faxNumber
                address2
                address1
                phoneNumber
                postalCode
                manualOrderFormUrl
              }
              createdAt
              updatedAt
            }
          }
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const DiscardOrderDocument = gql`
    mutation DiscardOrder($id: ID!, $clientMutationId: String = null) {
  discardOrder(input: {id: $id, clientMutationId: $clientMutationId}) {
    clientMutationId
  }
}
    `;
export const OrderFromEstimateDocument = gql`
    mutation OrderFromEstimate($id: ID!, $comments: JSONString = "[]", $clientMutationId: String = null) {
  orderFromEstimate(
    input: {id: $id, comments: $comments, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
    orderGroup {
      id
      orders {
        edges {
          node {
            id
            orderDetails {
              edges {
                cursor
                node {
                  id
                }
              }
            }
          }
          cursor
        }
      }
    }
  }
}
    `;
export const GetOrderGroupsCountDocument = gql`
    query GetOrderGroupsCount($isDiscarded: Boolean = null, $isOrdered: Boolean = null) {
  allOrderGroups(isDiscarded: $isDiscarded, isOrdered: $isOrdered) {
    totalCount
  }
}
    `;
export const GetPrefecturesDocument = gql`
    query GetPrefectures {
  allPrefectures {
    code
    name
  }
}
    `;
export const GetProfileDocument = gql`
    query GetProfile {
  me {
    email
    firstName
    firstNameKana
    id
    lastName
    lastNameKana
    phoneNumberPersonal
    phoneNumberWork
    teacherProfile {
      id
      customerId
      dateOfBirth
      discloseEmail
      nickname
      school {
        address
        faxNumber
        id
        name
        phoneNumber
        postalCode
        schoolCode
        cityCode
      }
      salesAgent {
        id
        name
        phoneNumber
        faxNumber
        postalCode
        address1
        address2
        manualOrderFormUrl
      }
      subjectAreas {
        edges {
          cursor
          node {
            id
            name
          }
        }
        pageInfo {
          startCursor
          hasPreviousPage
          hasNextPage
          endCursor
        }
      }
    }
    teacherAgents {
      edges {
        node {
          id
          approval
          salesAgent {
            id
            name
            phoneNumber
            postalCode
            faxNumber
            address2
            address1
            manualOrderFormUrl
          }
        }
        cursor
      }
      pageInfo {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
    }
  }
}
    `;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($email: String!, $firstName: String!, $firstNameKana: String!, $lastName: String!, $lastNameKana: String!, $nickname: String!, $phoneNumberPersonal: String!, $phoneNumberWork: String!, $school: ID!, $subjectAreas: [ID]!, $discloseEmail: Boolean!, $dateOfBirth: Date = null, $clientMutationId: String = null) {
  updateTeacherProfile(
    input: {school: $school, subjectAreas: $subjectAreas, lastName: $lastName, firstName: $firstName, lastNameKana: $lastNameKana, firstNameKana: $firstNameKana, nickname: $nickname, phoneNumberWork: $phoneNumberWork, phoneNumberPersonal: $phoneNumberPersonal, email: $email, clientMutationId: $clientMutationId, dateOfBirth: $dateOfBirth, discloseEmail: $discloseEmail}
  ) {
    clientMutationId
  }
}
    `;
export const GetPublisherDocument = gql`
    query GetPublisher($id: ID!) {
  publisher(id: $id) {
    id
    name
    shortName
    textbookPublisherNumber
  }
}
    `;
export const GetPublishersDocument = gql`
    query GetPublishers($isTextbookPublisher: Boolean = null) {
  allPublishers(isTextbookPublisher: $isTextbookPublisher) {
    edges {
      cursor
      node {
        id
        name
        shortName
        textbookPublisherNumber
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const GetQAndAsDocument = gql`
    query GetQAndAs {
  allQAndAs {
    edges {
      cursor
      node {
        content
        id
        title
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const ForcePasswordResetDocument = gql`
    mutation ForcePasswordReset($password: String!, $clientMutationId: String = null) {
  forceResetPassword(
    input: {password: $password, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
  }
}
    `;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!, $clientMutationId: String = null) {
  requestResetPassword(
    input: {email: $email, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
  }
}
    `;
export const PasswordResetDocument = gql`
    mutation PasswordReset($token: String!, $password: String!, $clientMutationId: String = null) {
  resetPassword(
    input: {token: $token, password: $password, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
  }
}
    `;
export const GetProductReviewStatusDocument = gql`
    query GetProductReviewStatus($id: ID!) {
  productReviewStatus(id: $id) {
    id
    isPurchased
    review {
      id
      review
      score
    }
  }
}
    `;
export const GetReviewDocument = gql`
    query GetReview($id: ID!) {
  review(id: $id) {
    id
    review
    score
    user {
      email
      teacherProfile {
        discloseEmail
        nickname
      }
    }
  }
}
    `;
export const GetReviewsDocument = gql`
    query GetReviews($offset: Int = null, $last: Int = null, $first: Int = null, $before: String = null, $after: String = null) {
  allReviews(
    after: $after
    before: $before
    first: $first
    last: $last
    offset: $offset
  ) {
    edges {
      cursor
      node {
        id
        review
        score
        user {
          email
          teacherProfile {
            discloseEmail
            nickname
          }
        }
        createdAt
      }
    }
  }
}
    `;
export const ReviewCreateDocument = gql`
    mutation ReviewCreate($sku: ID!, $score: Int!, $review: String!, $clientMutationId: String = null) {
  createReview(
    input: {sku: $sku, score: $score, review: $review, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
  }
}
    `;
export const GetSalesAgentsFilteredSchoolDocument = gql`
    query GetSalesAgentsFilteredSchool($after: String = null, $before: String = null, $first: Int = null, $last: Int = null) {
  allSalesAgentsFilteredSchool(
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        address1
        address2
        faxNumber
        id
        name
        phoneNumber
        postalCode
        manualOrderFormUrl
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const GetSalesAgentDocument = gql`
    query GetSalesAgent($id: ID!) {
  salesAgent(id: $id) {
    address1
    address2
    faxNumber
    id
    name
    phoneNumber
    postalCode
    manualOrderFormUrl
  }
}
    `;
export const GetSchoolsDocument = gql`
    query GetSchools($cityCode: String = null, $schoolCode: String = null, $schoolType: String = null, $after: String = null, $before: String = null, $first: Int = null, $last: Int = null, $offset: Int = null) {
  allSchools(
    cityCode: $cityCode
    schoolType: $schoolType
    schoolCode: $schoolCode
    after: $after
    before: $before
    first: $first
    last: $last
    offset: $offset
  ) {
    edges {
      cursor
      node {
        id
        name
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const GetSchoolDocument = gql`
    query GetSchool($id: ID!) {
  school(id: $id) {
    address
    faxNumber
    id
    name
    phoneNumber
    postalCode
    schoolCode
    cityCode
  }
}
    `;
export const GetSchoolSubjectsDocument = gql`
    query GetSchoolSubjects($school: ID!, $term: ID = null, $grade: ID = null, $subject: ID = null) {
  allSchoolSubjects(
    school: $school
    term: $term
    grade: $grade
    subject: $subject
  ) {
    edges {
      node {
        id
        publisher {
          textbookPublisherNumber
          shortName
          name
          id
        }
      }
      cursor
    }
    totalCount
  }
}
    `;
export const SignupDocument = gql`
    mutation Signup($email: String!, $password: String!, $firstName: String!, $firstNameKana: String!, $lastName: String!, $lastNameKana: String!, $nickname: String!, $phoneNumberPersonal: String!, $phoneNumberWork: String!, $school: ID!, $salesAgent: ID!, $subjectAreas: [ID]!, $discloseEmail: Boolean!, $dateOfBirth: Date = null, $clientMutationId: String = null) {
  signup(
    input: {school: $school, salesAgent: $salesAgent, subjectAreas: $subjectAreas, lastName: $lastName, firstName: $firstName, lastNameKana: $lastNameKana, firstNameKana: $firstNameKana, nickname: $nickname, phoneNumberWork: $phoneNumberWork, phoneNumberPersonal: $phoneNumberPersonal, email: $email, password: $password, clientMutationId: $clientMutationId, dateOfBirth: $dateOfBirth, discloseEmail: $discloseEmail}
  ) {
    clientMutationId
  }
}
    `;
export const GetSkuDocument = gql`
    query GetSku($id: ID!, $productReviewsAfter: String = null, $productReviewsBefore: String = null, $productReviewsFirst: Int = 5, $productReviewsOffset: Int = null, $productReviewsLast: Int = null) {
  sku(id: $id) {
    product {
      reviews(
        after: $productReviewsAfter
        before: $productReviewsBefore
        first: $productReviewsFirst
        offset: $productReviewsOffset
        last: $productReviewsLast
      ) {
        edges {
          node {
            id
            review
            score
            user {
              email
              teacherProfile {
                discloseEmail
                nickname
              }
            }
            createdAt
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
      id
      name
      productBaseCode
      rating
      subject {
        id
        name
        area {
          id
          name
        }
      }
    }
    imageUris {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        node {
          cdnUrl
          id
        }
        cursor
      }
    }
    available
    code
    grade {
      edges {
        cursor
        node {
          code
          gradeName
          gradeNumber
          id
          schoolType
          schoolTypeDisplay
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    id
    isbnCode
    janCode
    name
    publisherSkuUri
    regularPrice
    publisher {
      id
      name
    }
    relatedTextbookPublisher {
      id
      name
    }
    taxClass
    taxClassDisplay
    taxIncludedPrice
    taxRate
    term {
      id
      name
      year
    }
  }
}
    `;
export const GetProductReviewsDocument = gql`
    query GetProductReviews($id: ID!, $productReviewsAfter: String = null, $productReviewsBefore: String = null, $productReviewsFirst: Int = 10, $productReviewsOffset: Int = null, $productReviewsLast: Int = null) {
  sku(id: $id) {
    product {
      reviews(
        after: $productReviewsAfter
        before: $productReviewsBefore
        first: $productReviewsFirst
        offset: $productReviewsOffset
        last: $productReviewsLast
      ) {
        edges {
          node {
            id
            review
            score
            user {
              email
              teacherProfile {
                discloseEmail
                nickname
              }
            }
            createdAt
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
}
    `;
export const GetLatestSkuDocument = gql`
    query GetLatestSku($productId: ID!, $relatedTextbookPublisher: ID) {
  latestSku(
    productId: $productId
    relatedTextbookPublisher: $relatedTextbookPublisher
  ) {
    id
  }
}
    `;
export const SearchSkuDocument = gql`
    query SearchSku($after: String = null, $offset: Int = null, $available: Boolean = true, $before: String = null, $first: Int = 10, $grade: [ID] = null, $isbnCode: String = null, $isCompliantOnly: Boolean = null, $janCode: String = null, $janIsbnCode: String = null, $name: String = null, $product_Subject: ID = null, $product_Subject_Area: ID = null, $publisher_Name: String = null, $taxIncludedPrice_Gte: Int = null, $taxIncludedPrice_Lte: Int = null, $term: ID = null, $relatedTextbookPublisher: ID = null, $withoutNoRelatedTextbookPublisher: Boolean = null) {
  allSkus(
    after: $after
    offset: $offset
    available: $available
    before: $before
    first: $first
    grade: $grade
    isbnCode: $isbnCode
    isCompliantOnly: $isCompliantOnly
    janCode: $janCode
    janIsbnCode: $janIsbnCode
    name: $name
    product_Subject: $product_Subject
    product_Subject_Area: $product_Subject_Area
    publisher_Name: $publisher_Name
    taxIncludedPrice_Gte: $taxIncludedPrice_Gte
    taxIncludedPrice_Lte: $taxIncludedPrice_Lte
    term: $term
    relatedTextbookPublisher: $relatedTextbookPublisher
    withoutNoRelatedTextbookPublisher: $withoutNoRelatedTextbookPublisher
  ) {
    totalCount
    edges {
      node {
        available
        code
        id
        isbnCode
        janCode
        name
        publisherSkuUri
        regularPrice
        taxClass
        taxClassDisplay
        taxRate
        publisher {
          id
          name
          shortName
          textbookPublisherNumber
        }
        relatedTextbookPublisher {
          id
          name
          shortName
          textbookPublisherNumber
        }
        grade {
          edges {
            node {
              id
              gradeName
              gradeNumber
              schoolType
              schoolTypeDisplay
              code
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
        }
        term {
          id
          name
          year
        }
        taxIncludedPrice
        product {
          id
          name
          productBaseCode
          rating
          subject {
            id
            name
            area {
              name
            }
          }
        }
        imageUris {
          edges {
            cursor
            node {
              id
              cdnUrl
            }
          }
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
        }
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const GetSubjectAreasDocument = gql`
    query GetSubjectAreas {
  allSubjectAreas {
    edges {
      cursor
      node {
        id
        name
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const GetSubjectAreaDocument = gql`
    query GetSubjectArea($id: ID!) {
  subjectArea(id: $id) {
    id
    name
  }
}
    `;
export const GetSubjectsDocument = gql`
    query GetSubjects($area: ID = null) {
  allSubjects(area: $area) {
    edges {
      cursor
      node {
        id
        name
        area {
          id
          name
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const GetSubjectDocument = gql`
    query GetSubject($id: ID!) {
  subject(id: $id) {
    id
    name
    area {
      id
      name
    }
  }
}
    `;
export const GetTermDocument = gql`
    query GetTerm($id: ID!) {
  term(id: $id) {
    id
    name
    year
  }
}
    `;
export const GetTermsDocument = gql`
    query GetTerms($year: Int = null) {
  allTerms(year: $year) {
    edges {
      cursor
      node {
        id
        name
        year
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const TradeRequestDocument = gql`
    mutation TradeRequest($salesAgent: ID!, $clientMutationId: String = null) {
  requestTrade(
    input: {salesAgent: $salesAgent, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
    teacherAgent {
      id
      salesAgent {
        id
      }
    }
  }
}
    `;
export const TradeRequestCancelDocument = gql`
    mutation TradeRequestCancel($teacherAgent: ID!, $clientMutationId: String = null) {
  cancelTradeRequest(
    input: {teacherAgent: $teacherAgent, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
  }
}
    `;
export const GetTeacherAgentsDocument = gql`
    query GetTeacherAgents($after: String = null, $before: String = null, $first: Int = null, $last: Int = null, $offset: Int = null, $salesAgent: ID = null, $salesAgent_In: [ID] = null, $approval: Boolean = null) {
  allTeacherAgents(
    after: $after
    approval: $approval
    before: $before
    first: $first
    last: $last
    offset: $offset
    salesAgent: $salesAgent
    salesAgent_In: $salesAgent_In
  ) {
    edges {
      cursor
      node {
        approval
        id
        isHandledSchool
        salesAgent {
          address1
          address2
          faxNumber
          name
          phoneNumber
          postalCode
          id
          manualOrderFormUrl
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const GetUsingPurposeDocument = gql`
    query GetUsingPurpose($id: ID!) {
  usingPurpose(id: $id) {
    code
    id
    label
  }
}
    `;
export const GetUsingPurposesDocument = gql`
    query GetUsingPurposes {
  allUsingPurposes {
    edges {
      cursor
      node {
        code
        id
        label
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    AddCart(variables: AddCartMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddCartMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCartMutation>(AddCartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddCart', 'mutation', variables);
    },
    RemoveCartItem(variables: RemoveCartItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveCartItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveCartItemMutation>(RemoveCartItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveCartItem', 'mutation', variables);
    },
    UpdateCartItem(variables: UpdateCartItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCartItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCartItemMutation>(UpdateCartItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCartItem', 'mutation', variables);
    },
    GetCartItem(variables: GetCartItemQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCartItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCartItemQuery>(GetCartItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCartItem', 'query', variables);
    },
    GetCartItems(variables?: GetCartItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCartItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCartItemsQuery>(GetCartItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCartItems', 'query', variables);
    },
    GetCities(variables?: GetCitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCitiesQuery>(GetCitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCities', 'query', variables);
    },
    GetConfigs(variables?: GetConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetConfigsQuery>(GetConfigsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetConfigs', 'query', variables);
    },
    EmailVerify(variables: EmailVerifyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmailVerifyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailVerifyMutation>(EmailVerifyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EmailVerify', 'mutation', variables);
    },
    GetEmailVerify(variables: GetEmailVerifyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetEmailVerifyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEmailVerifyQuery>(GetEmailVerifyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetEmailVerify', 'query', variables);
    },
    RequestEstimate(variables?: RequestEstimateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RequestEstimateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestEstimateMutation>(RequestEstimateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RequestEstimate', 'mutation', variables);
    },
    CheckEstimatePdfGenerated(variables: CheckEstimatePdfGeneratedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckEstimatePdfGeneratedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckEstimatePdfGeneratedMutation>(CheckEstimatePdfGeneratedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CheckEstimatePdfGenerated', 'mutation', variables);
    },
    GetEstimateFileUrl(variables: GetEstimateFileUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetEstimateFileUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEstimateFileUrlMutation>(GetEstimateFileUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetEstimateFileUrl', 'mutation', variables);
    },
    GetGrade(variables: GetGradeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetGradeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetGradeQuery>(GetGradeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetGrade', 'query', variables);
    },
    GetGrades(variables?: GetGradesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetGradesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetGradesQuery>(GetGradesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetGrades', 'query', variables);
    },
    GetOrders(variables?: GetOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrdersQuery>(GetOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetOrders', 'query', variables);
    },
    ObtainOrderIdByGroupOrderId(variables: ObtainOrderIdByGroupOrderIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ObtainOrderIdByGroupOrderIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ObtainOrderIdByGroupOrderIdQuery>(ObtainOrderIdByGroupOrderIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ObtainOrderIdByGroupOrderId', 'query', variables);
    },
    GetLastUpdatedOrderDetail(variables?: GetLastUpdatedOrderDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetLastUpdatedOrderDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLastUpdatedOrderDetailQuery>(GetLastUpdatedOrderDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetLastUpdatedOrderDetail', 'query', variables);
    },
    OrderByCartItems(variables: OrderByCartItemsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderByCartItemsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderByCartItemsMutation>(OrderByCartItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OrderByCartItems', 'mutation', variables);
    },
    GetOrderGroup(variables: GetOrderGroupQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderGroupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderGroupQuery>(GetOrderGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetOrderGroup', 'query', variables);
    },
    GetOrderGroups(variables?: GetOrderGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderGroupsQuery>(GetOrderGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetOrderGroups', 'query', variables);
    },
    DiscardOrder(variables: DiscardOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DiscardOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DiscardOrderMutation>(DiscardOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DiscardOrder', 'mutation', variables);
    },
    OrderFromEstimate(variables: OrderFromEstimateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderFromEstimateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderFromEstimateMutation>(OrderFromEstimateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OrderFromEstimate', 'mutation', variables);
    },
    GetOrderGroupsCount(variables?: GetOrderGroupsCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderGroupsCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderGroupsCountQuery>(GetOrderGroupsCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetOrderGroupsCount', 'query', variables);
    },
    GetPrefectures(variables?: GetPrefecturesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPrefecturesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPrefecturesQuery>(GetPrefecturesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPrefectures', 'query', variables);
    },
    GetProfile(variables?: GetProfileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProfileQuery>(GetProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetProfile', 'query', variables);
    },
    UpdateProfile(variables: UpdateProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProfileMutation>(UpdateProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateProfile', 'mutation', variables);
    },
    GetPublisher(variables: GetPublisherQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPublisherQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPublisherQuery>(GetPublisherDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPublisher', 'query', variables);
    },
    GetPublishers(variables?: GetPublishersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPublishersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPublishersQuery>(GetPublishersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPublishers', 'query', variables);
    },
    GetQAndAs(variables?: GetQAndAsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetQAndAsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetQAndAsQuery>(GetQAndAsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetQAndAs', 'query', variables);
    },
    ForcePasswordReset(variables: ForcePasswordResetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ForcePasswordResetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ForcePasswordResetMutation>(ForcePasswordResetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ForcePasswordReset', 'mutation', variables);
    },
    RequestPasswordReset(variables: RequestPasswordResetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RequestPasswordResetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestPasswordResetMutation>(RequestPasswordResetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RequestPasswordReset', 'mutation', variables);
    },
    PasswordReset(variables: PasswordResetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PasswordResetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PasswordResetMutation>(PasswordResetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PasswordReset', 'mutation', variables);
    },
    GetProductReviewStatus(variables: GetProductReviewStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProductReviewStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductReviewStatusQuery>(GetProductReviewStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetProductReviewStatus', 'query', variables);
    },
    GetReview(variables: GetReviewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetReviewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetReviewQuery>(GetReviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetReview', 'query', variables);
    },
    GetReviews(variables?: GetReviewsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetReviewsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetReviewsQuery>(GetReviewsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetReviews', 'query', variables);
    },
    ReviewCreate(variables: ReviewCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReviewCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReviewCreateMutation>(ReviewCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReviewCreate', 'mutation', variables);
    },
    GetSalesAgentsFilteredSchool(variables?: GetSalesAgentsFilteredSchoolQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSalesAgentsFilteredSchoolQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSalesAgentsFilteredSchoolQuery>(GetSalesAgentsFilteredSchoolDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSalesAgentsFilteredSchool', 'query', variables);
    },
    GetSalesAgent(variables: GetSalesAgentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSalesAgentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSalesAgentQuery>(GetSalesAgentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSalesAgent', 'query', variables);
    },
    GetSchools(variables?: GetSchoolsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSchoolsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSchoolsQuery>(GetSchoolsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSchools', 'query', variables);
    },
    GetSchool(variables: GetSchoolQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSchoolQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSchoolQuery>(GetSchoolDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSchool', 'query', variables);
    },
    GetSchoolSubjects(variables: GetSchoolSubjectsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSchoolSubjectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSchoolSubjectsQuery>(GetSchoolSubjectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSchoolSubjects', 'query', variables);
    },
    Signup(variables: SignupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SignupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignupMutation>(SignupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Signup', 'mutation', variables);
    },
    GetSku(variables: GetSkuQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSkuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSkuQuery>(GetSkuDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSku', 'query', variables);
    },
    GetProductReviews(variables: GetProductReviewsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProductReviewsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductReviewsQuery>(GetProductReviewsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetProductReviews', 'query', variables);
    },
    GetLatestSku(variables: GetLatestSkuQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetLatestSkuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLatestSkuQuery>(GetLatestSkuDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetLatestSku', 'query', variables);
    },
    SearchSku(variables?: SearchSkuQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchSkuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchSkuQuery>(SearchSkuDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SearchSku', 'query', variables);
    },
    GetSubjectAreas(variables?: GetSubjectAreasQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSubjectAreasQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSubjectAreasQuery>(GetSubjectAreasDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSubjectAreas', 'query', variables);
    },
    GetSubjectArea(variables: GetSubjectAreaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSubjectAreaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSubjectAreaQuery>(GetSubjectAreaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSubjectArea', 'query', variables);
    },
    GetSubjects(variables?: GetSubjectsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSubjectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSubjectsQuery>(GetSubjectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSubjects', 'query', variables);
    },
    GetSubject(variables: GetSubjectQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSubjectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSubjectQuery>(GetSubjectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSubject', 'query', variables);
    },
    GetTerm(variables: GetTermQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTermQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTermQuery>(GetTermDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTerm', 'query', variables);
    },
    GetTerms(variables?: GetTermsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTermsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTermsQuery>(GetTermsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTerms', 'query', variables);
    },
    TradeRequest(variables: TradeRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TradeRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TradeRequestMutation>(TradeRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TradeRequest', 'mutation', variables);
    },
    TradeRequestCancel(variables: TradeRequestCancelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TradeRequestCancelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TradeRequestCancelMutation>(TradeRequestCancelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TradeRequestCancel', 'mutation', variables);
    },
    GetTeacherAgents(variables?: GetTeacherAgentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTeacherAgentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTeacherAgentsQuery>(GetTeacherAgentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTeacherAgents', 'query', variables);
    },
    GetUsingPurpose(variables: GetUsingPurposeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUsingPurposeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUsingPurposeQuery>(GetUsingPurposeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetUsingPurpose', 'query', variables);
    },
    GetUsingPurposes(variables?: GetUsingPurposesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUsingPurposesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUsingPurposesQuery>(GetUsingPurposesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetUsingPurposes', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;